import { render, staticRenderFns } from "./for_freelancers.vue?vue&type=template&id=32ab70da&scoped=true&"
import script from "./for_freelancers.vue?vue&type=script&lang=js&"
export * from "./for_freelancers.vue?vue&type=script&lang=js&"
import style0 from "./for_freelancers.vue?vue&type=style&index=0&id=32ab70da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ab70da",
  null
  
)

export default component.exports